<template>
    <v-card flat>
        <v-card-title class="px-0">
            <span class="subtitle-1 font-weight-medium">{{ title }}</span>
        </v-card-title>

        <!-- input fantasma anti-autocomplete -->
        <input type="text" style="display:none" />

        <v-form ref="formDireccion" v-model="valid" lazy-validation>
            <v-row>
                <v-col cols="12" md="8">
                    <v-text-field v-model="direccion.calle" label="Calle" outlined dense clearable autocomplete="off"
                        autocorrect="off" autocapitalize="off" spellcheck="false"
                        @input="direccion.calle = toUpperCaseGeneral(direccion.calle)" :rules="[rules.ruleRequired]" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field v-model="direccion.numero" label="Número" outlined dense autocomplete="off"
                        autocorrect="off" autocapitalize="off" spellcheck="false"
                        @input="direccion.numero = toUpperCaseGeneral(direccion.numero)" :rules="[rules.ruleRequired]" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field v-model="direccion.colonia" label="Colonia" outlined dense autocomplete="off"
                        autocorrect="off" autocapitalize="off" spellcheck="false"
                        @input="direccion.colonia = toUpperCaseGeneral(direccion.colonia)" :rules="[rules.ruleRequired]" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field v-model="direccion.cp" label="Código Postal" outlined dense autocomplete="off"
                        autocorrect="off" autocapitalize="off" spellcheck="false"
                        @input="direccion.cp = toUpperCaseGeneral(direccion.cp)" :rules="[rules.ruleRequired, rules.ruleCp]" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field v-model="direccion.ciudad" label="Ciudad / Municipio" outlined dense
                        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                        @input="direccion.ciudad = toUpperCaseGeneral(direccion.ciudad)" :rules="[rules.ruleRequired]" />
                </v-col>

                <v-col cols="12" md="6">
                    <v-select v-model="direccion.estado" :items="estadosMexico" label="Estado" outlined dense
                        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                </v-col>

                <v-col cols="12" md="6">
                    <v-text-field v-model="direccion.pais" label="País" outlined dense disabled />
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</template>

<script>
import upperCase from "@/mixins/upperCase";

export default {
    name: "DireccionForm",
    mixins: [upperCase],
    props: {
        value: Object,
        title: {
            type: String,
            default: "Dirección"
        },
        isRequired: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        rules() {
            return this.$rules;
        }
    },
    data() {
        return {
            valid: false,
            direccion: {
                calle: "",
                numero: "",
                colonia: "",
                cp: "",
                ciudad: "SAN LUIS POTOSÍ",
                estado: "SAN LUIS POTOSÍ",
                pais: "México"
            },
            estadosMexico: [
                "AGUASCALIENTES",
                "BAJA CALIFORNIA",
                "BAJA CALIFORNIA SUR",
                "CAMPECHE",
                "CHIAPAS",
                "CHIHUAHUA",
                "CIUDAD DE MÉXICO",
                "COAHUILA",
                "COLIMA",
                "DURANGO",
                "ESTADO DE MÉXICO",
                "GUANAJUATO",
                "GUERRERO",
                "HIDALGO",
                "JALISCO",
                "MICHOACÁN",
                "MORELOS",
                "NAYARIT",
                "NUEVO LEÓN",
                "OAXACA",
                "PUEBLA",
                "QUERÉTARO",
                "QUINTANA ROO",
                "SAN LUIS POTOSÍ",
                "SINALOA",
                "SONORA",
                "TABASCO",
                "TAMAULIPAS",
                "TLAXCALA",
                "VERACRUZ",
                "YUCATÁN",
                "ZACATECAS"
            ]
        };
    },
    value: {
        immediate: true,
        deep: true,
        handler(val) {
            if (val) {
                this.direccion = { ...this.direccion, ...val };
            }
        }
    }
    ,
    methods: {
        validate() {
            return this.$refs.formDireccion.validate();
        },
        sync() {
            this.$nextTick(() => {
                this.$refs.formDireccion?.validate();
            });
        }
    }
};
</script>
